import * as React from 'react';
import { Avatar, AvatarProps } from '@mui/material';

export default function AvatarWithStatus (props: AvatarProps) {
  return (
    <Avatar sizes='sm' {...props} />
  );
}
